import { Observable } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { UserProfile } from 'src/app/core/models/user';
import { MenuItemModel } from 'src/app/core/models/analytics/menu-item-model';
import { AnalyticsService } from './../../../core/services/analytics/analytics.service';

@Component({
  selector: 'app-user-management-landing',
  templateUrl: './user-management-landing.component.html',
  styleUrls: ['./user-management-landing.component.scss']
})
export class UserManagementLandingComponent implements OnInit {

  libraryMenu: Array<MenuItemModel>;
  loggedInUser: UserProfile;
  currentUser: Observable<UserProfile> = new Observable<UserProfile>();

  constructor(
    private analyticsService: AnalyticsService
  ) {
    this.libraryMenu = [];
    this.loggedInUser = new UserProfile();
  }

  ngOnInit(): void {
    this.getUserMenu();
  }

  getUserMenu(): void {
    this.analyticsService.getLibraryMenu().subscribe((data: MenuItemModel[]) => {
      this.libraryMenu = data;
    });
  }

  checkRoutePermission(currentUrl: string): boolean {
    return this.libraryMenu.find(a => a.screenUrl === currentUrl && a.parentId > 0) ? true : false;
  }
}
